import { AxiosError } from "axios";
import { ReactNode } from "react";
import { isNil } from "lodash";

import { Error404, ServerError } from "../views";

import { FullScreenSpinner } from "./FullScreenSpinner";

interface LoaderProps {
  isLoading: boolean;
  data: unknown;
  error: AxiosError | null;
  children: ReactNode;
}

export function Loader({ isLoading, error, data, children }: LoaderProps) {
  if (isLoading) return <FullScreenSpinner />;
  if (error) return <ServerError status={error?.response?.status ?? 500} />;
  if (isNil(data)) return <Error404 />;

  return <>{children}</>;
}
